import { UseFormRegisterReturn } from "react-hook-form"
import { FormSelect } from "./Select"
import { ForwardedRef, forwardRef } from "react"
import { completeDistributionTariffOptions, distributionTariffOptions } from "@nano-portal/customers"

type Props = {
  id?: string
  error?: string
  success?: boolean
  formRegisterProps?: UseFormRegisterReturn
  displayBusinessTariffs?: boolean
}

function DistributionTariffSelectRaw(props: Props, ref: ForwardedRef<HTMLSelectElement>) {
  const { id, displayBusinessTariffs, ...rest } = props
  return (
    <FormSelect
      id={id}
      ref={ref}
      options={displayBusinessTariffs ? completeDistributionTariffOptions : distributionTariffOptions}
      placeholder="Vyberte distribuční sazbu"
      required
      {...rest}
    />
  )
}

export const DistributionTariffSelect = forwardRef(DistributionTariffSelectRaw)
